class ConnectivityService {
  private _syncFns: Array<() => void> = [];
  private _indicator: HTMLElement | null = null;

  init(): void {
    this._indicator = document.createElement("div");
    this._indicator.className = "connectivity-offline-indicator";
    this._indicator.innerHTML = '<i class="ph ph-wifi-slash"></i> Sin conexión';
    this._indicator.style.display = "none";
    document.body.appendChild(this._indicator);

    window.addEventListener("online", () => this._handleOnline());
    window.addEventListener("offline", () => this._handleOffline());

    if (!navigator.onLine) this._handleOffline();
  }

  setSyncs(fns: Array<() => void>): void {
    this._syncFns = fns;
  }

  private _handleOnline(): void {
    if (this._indicator) this._indicator.style.display = "none";
    this._syncFns.forEach((fn) => { try { fn(); } catch {} });
  }

  private _handleOffline(): void {
    if (this._indicator) this._indicator.style.display = "flex";
  }
}

export const connectivityService = new ConnectivityService();
